module.exports = __webpack_public_path__ + "img/icon-png.80274590.png";